"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  "use strict";

  var moduleName = "damages.scheduleDepa";
  var componentName = "scheduleDepa";

  var bindings = {
    resolve: "<?",
    infos: "=?"
  };

  var templateUrl = "app/pages/damages/scheduleDepa/scheduleDepa.html";

  var Controller = function () {
    /** @ngInject */
    function Controller($rootScope, $scope, $timeout, $window, DepasService, UsersService, OperatorsService, CustomListsService, CustomersService, ModalService, APP_URL) {
      _classCallCheck(this, Controller);

      this.log = debug("pages:damages:scheduleDepa");

      this.log(moduleName + "/" + componentName);

      this.$rootScope = $rootScope;

      this.$scope = $scope;
      this.$timeout = $timeout;
      this.$window = $window;
      this.UsersService = UsersService;
      this.DepasService = DepasService;
      this.OperatorsService = OperatorsService;
      this.CustomListsService = CustomListsService;
      this.CustomersService = CustomersService;
      this.ModalService = ModalService;
      this.APP_URL = APP_URL;

      this.infos = {};
    }

    _createClass(Controller, [{
      key: "displaySlot",
      value: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var that;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  that = this;
                  _context.next = 3;
                  return this.ModalService.openComponent("choice-slot", {
                    size: "lg",
                    depaId: this._id
                  }).then(function (slot) {
                    that.infos.slot = slot ? slot : that.infos.slot;
                  }).catch(function (err) {
                    console.error("err", err);
                  });

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function displaySlot() {
          return _ref.apply(this, arguments);
        }

        return displaySlot;
      }()
    }, {
      key: "setContact",
      value: function setContact(value) {
        this.position = value;

        this.infos.scheduleUserName = "";
        this.infos.phoneToUse = "";
        this.infos.emailToUse = "";

        if (value === "Conducteur") {
          this.infos.scheduleUserName = this.driver.firstName + " " + this.driver.lastName;
          this.infos.phoneToUse = this.driver.cellularPhone;
          this.infos.emailToUse = this.driver.email;
        } else if (value === this.$rootScope.defaultManagerValue && this.manager) {
          this.infos.scheduleUserName = this.manager.firstName + " " + this.manager.lastName;
          this.infos.phoneToUse = this.manager.cellularPhone;
          this.infos.emailToUse = this.manager.email;
        } else if (value === this.$rootScope.rhManagerValue && this.rhManager) {
          this.infos.scheduleUserName = this.rhManager.firstName + " " + this.rhManager.lastName;
          this.infos.phoneToUse = this.rhManager.cellularPhone;
          this.infos.emailToUse = this.rhManager.email;
        } else if (value === this.$rootScope.qseManagerValue && this.qseManager) {
          this.infos.scheduleUserName = this.qseManager.firstName + " " + this.qseManager.lastName;
          this.infos.phoneToUse = this.qseManager.cellularPhone;
          this.infos.emailToUse = this.qseManager.email;
        } else if (value === this.$rootScope.fleetManagerValue && this.fleetManager) {
          this.infos.scheduleUserName = this.fleetManager.firstName + " " + this.fleetManager.lastName;
          this.infos.phoneToUse = this.fleetManager.cellularPhone;
          this.infos.emailToUse = this.fleetManager.email;
        } else if (value === this.$rootScope.other1ManagerValue && this.other1Manager) {
          this.infos.scheduleUserName = this.other1Manager.firstName + " " + this.other1Manager.lastName;
          this.infos.phoneToUse = this.other1Manager.cellularPhone;
          this.infos.emailToUse = this.other1Manager.email;
        } else if (value === this.$rootScope.other2ManagerValue && this.other2Manager) {
          this.infos.scheduleUserName = this.other2Manager.firstName + " " + this.other2Manager.lastName;
          this.infos.phoneToUse = this.other2Manager.cellularPhone;
          this.infos.emailToUse = this.other2Manager.email;
        } else if (value === "Responsable du suivi" && this.damageManager) {
          this.infos.scheduleUserName = this.damageManager.firstName + " " + this.damageManager.lastName;
          this.infos.phoneToUse = this.damageManager.cellularPhone;
          this.infos.emailToUse = this.damageManager.email;
        }
      }
    }, {
      key: "setMode",
      value: function setMode(mode) {
        this.mode = mode;

        if (this.mode === "scheduleLvr") {
          this.infos.slot = this.slot;
          this.infos.phone = this.phone;
          this.infos.note = this.note;
        } else if (this.mode === "mailOrSms") {
          this.infos.phoneToUse = "";
          this.infos.emailToUse = "";
          this.infos.scheduleUserName = "";
          this.infos.note = this.note;
        } else if (this.mode === "comment") {
          this.infos.note = this.note;
        }
      }
    }, {
      key: "setSlotNow",
      value: function setSlotNow() {
        var _this = this;

        // Set start
        var now = new Date();
        var hour = now.getHours();
        var minute = now.getMinutes();
        if (minute >= 0 && minute < 8) {
          minute = 0;
        } else if (minute >= 8 && minute < 23) {
          minute = 15;
        } else if (minute >= 23 && minute < 38) {
          minute = 30;
        } else if (minute >= 38 && minute < 53) {
          minute = 45;
        } else {
          hour += 1;
          minute = 0;
        }
        var start = moment(now).set({ hour: hour, minute: minute, second: 0, millisecond: 0 }).toDate();

        // Set end
        var slotDuration = 30; // max

        var typeOfAccidentData = this.typeOfAccidentList.find(function (item) {
          return item.value === _this.typeOfAccident;
        });
        if (typeOfAccidentData && typeOfAccidentData.data) {
          var typeOfAccident = JSON.parse(typeOfAccidentData.data);
          if (typeOfAccident.slotDuration) {
            slotDuration = typeOfAccident.slotDuration;
          }
        }
        // security:
        if (slotDuration !== 30 && slotDuration !== 15) {
          slotDuration = 30;
        }

        var end = moment(start).add(slotDuration, "m").toDate();

        this.infos.slot = {
          start: start,
          end: end,
          operatorId: "$" + this.$rootScope.$user._id,
          operatorName: this.$rootScope.$user.lastName + " " + this.$rootScope.$user.firstName,
          comment: "no check"
        };
      }
    }, {
      key: "normalizeToE164",
      value: function normalizeToE164(phone) {
        if (!phone) return phone;
        var normalized = phone.replace(/[\s.\-()]/g, "");
        if (/^00[1-9]\d{6,13}$/.test(normalized)) {
          normalized = "+" + normalized.slice(2);
        } else if (/^0\d{9}$/.test(normalized)) {
          normalized = "+33" + normalized.slice(1);
        }
        return normalized;
      }
    }, {
      key: "save",
      value: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var response, values, _response;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (this.infos.phone) {
                    this.infos.phone = this.normalizeToE164(this.infos.phone);
                  }
                  if (this.infos.phoneToUse) {
                    this.infos.phoneToUse = this.normalizeToE164(this.infos.phoneToUse);
                  }

                  console.log("need to save", this.infos);

                  // Cas de la prise de RDV par LVR (sauf si forçage, modif conseiller ou suppression créneau)

                  if (!(this.slot != this.infos.slot && this.infos.slot.comment !== "no check")) {
                    _context2.next = 35;
                    break;
                  }

                  if (this.infos.slot) {
                    _context2.next = 8;
                    break;
                  }

                  _context2.next = 7;
                  return swal("", "Vous n'avez pas sélectionné de créneau horaire.", "error");

                case 7:
                  return _context2.abrupt("return");

                case 8:
                  if (this.infos.phone) {
                    _context2.next = 12;
                    break;
                  }

                  _context2.next = 11;
                  return swal("", "Vous n'avez pas indiqué le numéro de téléphone pour joindre le collaborateur", "error");

                case 11:
                  return _context2.abrupt("return");

                case 12:
                  if (!(this.validatePhone(this.infos.phone) === false)) {
                    _context2.next = 16;
                    break;
                  }

                  _context2.next = 15;
                  return swal("", "Le format du téléphone n'est pas valide.", "error");

                case 15:
                  return _context2.abrupt("return");

                case 16:

                  Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");
                  _context2.prev = 17;
                  _context2.next = 20;
                  return this.DepasService.post("mobile/makeAppointment", {
                    data: {
                      depaId: this._id.replace("$", ""),
                      slot: this.infos.slot,
                      phone: this.infos.phone,
                      note: this.infos.note
                    }
                  });

                case 20:
                  response = _context2.sent;

                  if (response.success) {
                    _context2.next = 25;
                    break;
                  }

                  Notiflix.Loading.remove();
                  Notiflix.Notify.failure("Le créneau n'est pas disponible ou une erreur est survenue.");
                  return _context2.abrupt("return");

                case 25:
                  Notiflix.Notify.success("La demande a bien été prise en compte.");
                  Notiflix.Loading.remove();
                  _context2.next = 33;
                  break;

                case 29:
                  _context2.prev = 29;
                  _context2.t0 = _context2["catch"](17);

                  Notiflix.Loading.remove();
                  Notiflix.Notify.failure("Le créneau n'est pas disponible ou une erreur est survenue.");

                case 33:
                  this.close();
                  return _context2.abrupt("return");

                case 35:
                  if (!(this.mode != "scheduleLvr" && this.mode != "comment" && (!this.infos.scheduleUserName || this.infos.scheduleUserName.length == 0))) {
                    _context2.next = 40;
                    break;
                  }

                  _context2.next = 38;
                  return swal("", "Vous n'avez pas indiqué le nom du contact", "error");

                case 38:
                  _context2.next = 90;
                  break;

                case 40:
                  if (!(this.mode == "scheduleLvr" && !this.infos.phone)) {
                    _context2.next = 45;
                    break;
                  }

                  _context2.next = 43;
                  return swal("", "Vous n'avez pas indiqué le numéro de téléphone pour joindre le collaborateur", "error");

                case 43:
                  _context2.next = 90;
                  break;

                case 45:
                  if (!(this.mode == "scheduleLvr" && this.infos.phone && this.validatePhone(this.infos.phone) === false)) {
                    _context2.next = 50;
                    break;
                  }

                  _context2.next = 48;
                  return swal("", "Le format du téléphone n'est pas valide.", "error");

                case 48:
                  _context2.next = 90;
                  break;

                case 50:
                  if (!(this.mode != "scheduleLvr" && this.mode != "comment" && !this.infos.phoneToUse && !this.infos.emailToUse)) {
                    _context2.next = 55;
                    break;
                  }

                  _context2.next = 53;
                  return swal("", "Vous n'avez pas indiqué un email ou un portable", "error");

                case 53:
                  _context2.next = 90;
                  break;

                case 55:
                  if (!(this.infos.emailToUse && this.validateEmail(this.infos.emailToUse) === false)) {
                    _context2.next = 60;
                    break;
                  }

                  _context2.next = 58;
                  return swal("", "Le format de l'email n'est pas valide.", "error");

                case 58:
                  _context2.next = 90;
                  break;

                case 60:
                  if (!(this.infos.phoneToUse && this.validatePhone(this.infos.phoneToUse) === false)) {
                    _context2.next = 65;
                    break;
                  }

                  _context2.next = 63;
                  return swal("", "Le format du portable n'est pas valide.", "error");

                case 63:
                  _context2.next = 90;
                  break;

                case 65:
                  values = void 0;

                  if (this.mode === "scheduleLvr") {
                    values = {};
                    // Sécurité : on ne sauvegarde que ce qui a changé pour éviter d'écraser des données
                    if (this.infos.slot) {
                      values.slot = this.infos.slot;
                    }
                    if (this.infos.phone) {
                      values.phone = this.infos.phone;
                    }
                    if (this.infos.note || this.infos.note === "") {
                      values.note = this.infos.note;
                    }
                  } else if (this.mode === "comment") {
                    values = {
                      note: this.infos.note
                    };
                  } else {
                    values = {
                      scheduleUserName: this.infos.scheduleUserName,
                      emailToUse: this.infos.emailToUse,
                      phoneToUse: this.infos.phoneToUse,
                      note: this.infos.note
                    };
                  }

                  _context2.next = 69;
                  return this.DepasService.findById({
                    _id: this._id.replace("$", "")
                  });

                case 69:
                  this.depa = _context2.sent;


                  if (values.scheduleUserName) {
                    values.emailName = "toScheduled";
                    if (this.depa.status === "Annulé") {
                      values.emailName = "meetingCancel";
                    } else {
                      if (this.depa.status.endsWith("A reprogrammer")) {
                        values.emailName = "driverNotAvailable";
                      }
                    }
                  }
                  Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");
                  _context2.prev = 72;
                  _context2.next = 75;
                  return this.DepasService.updateAttributesById(this._id.replace("$", ""), values);

                case 75:
                  _response = _context2.sent;

                  if (_response._id) {
                    _context2.next = 80;
                    break;
                  }

                  Notiflix.Loading.remove();
                  Notiflix.Notify.failure("Une erreur est survenue lors de la sauvegarde.");
                  return _context2.abrupt("return");

                case 80:
                  Notiflix.Loading.remove();
                  Notiflix.Notify.success("La demande a bien été prise en compte.");
                  _context2.next = 88;
                  break;

                case 84:
                  _context2.prev = 84;
                  _context2.t1 = _context2["catch"](72);

                  Notiflix.Loading.remove();
                  Notiflix.Notify.failure("Une erreur est survenue lors de la sauvegarde.");

                case 88:
                  this.close();
                  return _context2.abrupt("return");

                case 90:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[17, 29], [72, 84]]);
        }));

        function save() {
          return _ref2.apply(this, arguments);
        }

        return save;
      }()
    }, {
      key: "validatePhone",
      value: function validatePhone(phone) {
        var re = /^\+[1-9]\d{6,14}$/;
        return re.test(phone);
      }
    }, {
      key: "validateEmail",
      value: function validateEmail(email) {
        var isValid = true;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = email.split(",")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(item)) {
              isValid = false;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isValid;
      }
    }, {
      key: "checkBeforeClose",
      value: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!(this.keyboard === true)) {
                    _context3.next = 4;
                    break;
                  }

                  this.close(null);
                  _context3.next = 17;
                  break;

                case 4:
                  _context3.next = 6;
                  return this.DepasService.findById({
                    _id: this._id.replace("$", "")
                  });

                case 6:
                  this.depa = _context3.sent;

                  if (!(this.depa.slot && this.depa.slot.start)) {
                    _context3.next = 11;
                    break;
                  }

                  this.close(null);
                  _context3.next = 17;
                  break;

                case 11:
                  if (!this.isLvr) {
                    _context3.next = 15;
                    break;
                  }

                  this.close(null);
                  _context3.next = 17;
                  break;

                case 15:
                  _context3.next = 17;
                  return swal("", "Vous n'avez pas sélectionné de créneau horaire ou indiqué la personne qui recevra le lien.", "error");

                case 17:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function checkBeforeClose() {
          return _ref3.apply(this, arguments);
        }

        return checkBeforeClose;
      }()
    }, {
      key: "cancelDepa",
      value: function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
          var data, response;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");
                  data = { meetingCancel: true, reasonCancel: "byCustomer" };
                  _context4.prev = 2;
                  _context4.next = 5;
                  return this.DepasService.updateAttributesById(this._id.replace("$", ""), data);

                case 5:
                  response = _context4.sent;

                  if (response._id) {
                    _context4.next = 10;
                    break;
                  }

                  Notiflix.Loading.remove();
                  Notiflix.Notify.failure("Une erreur est survenue lors de la sauvegarde.");
                  return _context4.abrupt("return");

                case 10:
                  Notiflix.Loading.remove();
                  _context4.next = 17;
                  break;

                case 13:
                  _context4.prev = 13;
                  _context4.t0 = _context4["catch"](2);

                  Notiflix.Loading.remove();
                  Notiflix.Notify.failure("Une erreur est survenue lors de la sauvegarde.");

                case 17:
                  this.close(null);

                case 18:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this, [[2, 13]]);
        }));

        function cancelDepa() {
          return _ref4.apply(this, arguments);
        }

        return cancelDepa;
      }()
    }, {
      key: "setSlotOperator",
      value: function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
          var value, select, operators, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, operator, option, operatorChange, operatorName;

          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  value = void 0;
                  select = document.createElement("select");

                  select.className = "form-control";

                  _context5.next = 5;
                  return this.OperatorsService.getSelectArray();

                case 5:
                  operators = _context5.sent;
                  _iteratorNormalCompletion2 = true;
                  _didIteratorError2 = false;
                  _iteratorError2 = undefined;
                  _context5.prev = 9;

                  for (_iterator2 = operators[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    operator = _step2.value;
                    option = document.createElement("option");

                    option.innerHTML = operator.name;
                    option.value = operator.value;
                    option.selected = this.infos.slot.operatorId === operator.value;
                    select.appendChild(option);
                  }

                  _context5.next = 17;
                  break;

                case 13:
                  _context5.prev = 13;
                  _context5.t0 = _context5["catch"](9);
                  _didIteratorError2 = true;
                  _iteratorError2 = _context5.t0;

                case 17:
                  _context5.prev = 17;
                  _context5.prev = 18;

                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }

                case 20:
                  _context5.prev = 20;

                  if (!_didIteratorError2) {
                    _context5.next = 23;
                    break;
                  }

                  throw _iteratorError2;

                case 23:
                  return _context5.finish(20);

                case 24:
                  return _context5.finish(17);

                case 25:
                  select.onchange = function selectChanged(e) {
                    value = e.target.value;
                  };

                  _context5.next = 28;
                  return swal({
                    title: "Voulez-vous modifier le conseiller ou la conseill\xE8re ?",
                    text: "Conseiller/ère : ",
                    content: {
                      element: select
                    },
                    icon: "warning",
                    dangerMode: true,
                    buttons: ["Annuler", "Valider"]
                  });

                case 28:
                  operatorChange = _context5.sent;


                  if (operatorChange && value) {
                    operatorName = operators.find(function (operator) {
                      return operator.value === value;
                    }).name;


                    this.infos.slot = {
                      start: this.infos.slot.start,
                      end: this.infos.slot.end,
                      operatorId: value,
                      operatorName: operatorName,
                      comment: "no check"
                    };
                    // https://stackoverflow.com/questions/34907903/angularjs-scope-not-updating-in-view-after-async-call
                    this.$scope.$applyAsync();
                  } else if (operatorChange) {
                    Notiflix.Notify.warning("Veuillez choisir un conseiller ou une conseillère avant de valider !");
                  }

                case 30:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this, [[9, 13, 17, 25], [18,, 20, 24]]);
        }));

        function setSlotOperator() {
          return _ref5.apply(this, arguments);
        }

        return setSlotOperator;
      }()
    }, {
      key: "removeSlot",
      value: function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
          var select, reason, textarea, div, action, note, oldSlot, data, response;
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  select = document.createElement("select");

                  select.className = "form-control";

                  reason = "";
                  textarea = document.createElement("textarea");

                  textarea.innerHTML = "";
                  textarea.className = "form-control";
                  textarea.onchange = function selectChanged(e) {
                    reason = e.target.value;
                  };

                  // const label = document.createElement('label');
                  // label.innerHTML = ""

                  div = document.createElement("div");
                  // div.appendChild(label);

                  div.appendChild(textarea);

                  _context6.next = 11;
                  return swal({
                    title: "Voulez-vous supprimer ce RDV ?",
                    text: "Raison :",
                    content: {
                      element: div
                    },
                    icon: "warning",
                    dangerMode: true,
                    buttons: ["Annuler", "Valider"]
                  });

                case 11:
                  action = _context6.sent;

                  if (!(action && reason)) {
                    _context6.next = 36;
                    break;
                  }

                  note = this.infos.note ? this.infos.note + " - " : "";
                  oldSlot = {
                    date: new Date(),
                    start: this.slot.start,
                    end: this.slot.end,
                    operatorId: this.slot.operatorId
                  };

                  note += "RDV supprimé par " + this.$rootScope.$user.firstName + " " + this.$rootScope.$user.lastName + " car : " + reason;
                  data = {
                    status: "Nouveau à programmer",
                    slot: null,
                    note: note,
                    informOperator: oldSlot,
                    emailName: "meetingRemoved"
                  };

                  Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

                  // TODO: save history !
                  _context6.prev = 18;
                  _context6.next = 21;
                  return this.DepasService.updateAttributesById(this._id, data);

                case 21:
                  response = _context6.sent;

                  if (response._id) {
                    _context6.next = 26;
                    break;
                  }

                  Notiflix.Loading.remove();
                  Notiflix.Notify.failure("Une erreur est survenue lors de la sauvegarde.");
                  return _context6.abrupt("return");

                case 26:
                  Notiflix.Loading.remove();
                  _context6.next = 33;
                  break;

                case 29:
                  _context6.prev = 29;
                  _context6.t0 = _context6["catch"](18);

                  Notiflix.Loading.remove();
                  Notiflix.Notify.failure("Une erreur est survenue lors de la sauvegarde.");

                case 33:
                  this.close(null);
                  _context6.next = 37;
                  break;

                case 36:
                  if (action) {
                    Notiflix.Notify.warning("Veuillez indiquer une raison avant de valider !");
                  }

                case 37:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this, [[18, 29]]);
        }));

        function removeSlot() {
          return _ref6.apply(this, arguments);
        }

        return removeSlot;
      }()
    }, {
      key: "openScheduleApp",
      value: function openScheduleApp() {
        var url = this.APP_URL + "?shortId=" + this.shortId;
        this.ModalService.openComponent("custom-iframe", {
          source: url,
          size: "lg",
          heightCalculationMethod: "bodyOffset",
          minHeight: 850,
          closeEvent: "init",
          color: "#004369"
        }).then(function () {
          console.log("close modal");
        }).catch(function (err) {
          console.error("err", err);
        });
      }
    }, {
      key: "close",
      value: function close(infos) {
        this.log("$scope", this.$scope);

        if (this.$scope.$parent) {
          this.$scope.$parent.$close(infos);
        }
      }
    }, {
      key: "$onInit",
      value: function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
          var _this2 = this;

          var customer;
          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

                  this._id = this.resolve.params._id;
                  this.keyboard = typeof this.resolve.params.keyboard === "boolean" ? this.resolve.params.keyboard : true;
                  this.driver = this.resolve.params.driver;
                  this.typeOfAccident = this.resolve.params.typeOfAccident;
                  this.depaId = this.resolve.params.depaId;
                  this.shortId = this.resolve.params.shortId;
                  this.phone = this.resolve.params.phone;
                  this.note = this.resolve.params.note;
                  this.slot = this.resolve.params.slot;
                  this.phoneToUse = this.resolve.params.phoneToUse;
                  this.emailToUse = this.resolve.params.emailToUse;
                  this.scheduleUserName = this.resolve.params.scheduleUserName;
                  this.damageManagerId = this.resolve.params.damageManagerId;
                  this.depaStatus = this.resolve.params.depaStatus;
                  this.depaMissingCount = this.resolve.params.depaMissingCount ? this.resolve.params.depaMissingCount : 0;

                  this.isLvr = this.$rootScope.$user && this.$rootScope.$user.role && ["super-admin", "super-operator", "operator"].indexOf(this.$rootScope.$user.role) > -1 ? true : false;
                  this.isOperator = this.isLvr && this.$rootScope.$user.positions && this.$rootScope.$user.positions.includes("Opérateur");
                  this.isSuperAdmin = this.$rootScope.$user && this.$rootScope.$user.role && ["super-admin"].indexOf(this.$rootScope.$user.role) > -1 ? true : false;

                  this.isTomorrowOrAfter = !this.slot || moment(this.slot.start).isAfter(new Date(), "day");

                  _context7.next = 22;
                  return this.CustomersService.findById({
                    _id: this.$rootScope.$selectedCustomerId.replace("$", "")
                  });

                case 22:
                  customer = _context7.sent;
                  _context7.next = 25;
                  return this.CustomListsService.getSelectArray("typePosition");

                case 25:
                  this.positions = _context7.sent;

                  this.positions = this.positions.filter(function (item) {
                    if (item.value === _this2.$rootScope.rhManagerValue && _this2.$rootScope.rhManagerHidden) {
                      return false;
                    } else if (item.value === _this2.$rootScope.qseManagerValue && _this2.$rootScope.qseManagerHidden) {
                      return false;
                    } else if (item.value === _this2.$rootScope.fleetManagerValue && _this2.$rootScope.fleetManagerHidden) {
                      return false;
                    } else if (item.value === _this2.$rootScope.other1ManagerValue && _this2.$rootScope.other1ManagerHidden) {
                      return false;
                    } else if (item.value === _this2.$rootScope.other2ManagerValue && _this2.$rootScope.other2ManagerHidden) {
                      return false;
                    } else {
                      return ["Conducteur", _this2.$rootScope.defaultManagerValue, _this2.$rootScope.rhManagerValue, _this2.$rootScope.qseManagerValue, _this2.$rootScope.fleetManagerValue, _this2.$rootScope.other1ManagerValue, _this2.$rootScope.other2ManagerValue].includes(item.value);
                    }
                  }).map(function (item) {
                    var newItem = {};
                    newItem.value = item.value;
                    if (item.value === _this2.$rootScope.defaultManagerValue) {
                      newItem.name = customer.defaultManagerLabel ? customer.defaultManagerLabel : item.name;
                    } else if (item.value === _this2.$rootScope.rhManagerValue) {
                      newItem.name = customer.rhManagerLabel ? customer.rhManagerLabel : item.name;
                    } else if (item.value === _this2.$rootScope.qseManagerValue) {
                      newItem.name = customer.qseManagerLabel ? customer.qseManagerLabel : item.name;
                    } else if (item.value === _this2.$rootScope.fleetManagerValue) {
                      newItem.name = customer.fleetManagerLabel ? customer.fleetManagerLabel : item.name;
                    } else if (item.value === _this2.$rootScope.other1ManagerValue) {
                      newItem.name = customer.other1ManagerLabel ? customer.other1ManagerLabel : item.name;
                    } else if (item.value === _this2.$rootScope.other2ManagerValue) {
                      newItem.name = customer.other2ManagerLabel ? customer.other2ManagerLabel : item.name;
                    } else {
                      newItem.name = item.name;
                    }
                    return newItem;
                  });
                  this.positions.push({
                    value: "Responsable du suivi",
                    name: "Responsable du suivi"
                  });

                  if (!this.driver.defaultManagerId) {
                    _context7.next = 32;
                    break;
                  }

                  _context7.next = 31;
                  return this.UsersService.getById(this.driver.defaultManagerId);

                case 31:
                  this.manager = _context7.sent;

                case 32:
                  if (!this.driver.rhManagerId) {
                    _context7.next = 36;
                    break;
                  }

                  _context7.next = 35;
                  return this.UsersService.getById(this.driver.rhManagerId);

                case 35:
                  this.rhManager = _context7.sent;

                case 36:
                  if (!this.driver.qseManagerId) {
                    _context7.next = 40;
                    break;
                  }

                  _context7.next = 39;
                  return this.UsersService.getById(this.driver.qseManagerId);

                case 39:
                  this.qseManager = _context7.sent;

                case 40:
                  if (!this.driver.fleetManagerId) {
                    _context7.next = 44;
                    break;
                  }

                  _context7.next = 43;
                  return this.UsersService.getById(this.driver.fleetManagerId);

                case 43:
                  this.fleetManager = _context7.sent;

                case 44:
                  if (!this.driver.other1ManagerId) {
                    _context7.next = 48;
                    break;
                  }

                  _context7.next = 47;
                  return this.UsersService.getById(this.driver.other1ManagerId);

                case 47:
                  this.other1Manager = _context7.sent;

                case 48:
                  if (!this.driver.other2ManagerId) {
                    _context7.next = 52;
                    break;
                  }

                  _context7.next = 51;
                  return this.UsersService.getById(this.driver.other2ManagerId);

                case 51:
                  this.other2Manager = _context7.sent;

                case 52:
                  if (!this.damageManagerId) {
                    _context7.next = 56;
                    break;
                  }

                  _context7.next = 55;
                  return this.UsersService.getById(this.damageManagerId);

                case 55:
                  this.damageManager = _context7.sent;

                case 56:
                  if (!this.isLvr) {
                    _context7.next = 67;
                    break;
                  }

                  _context7.next = 59;
                  return this.CustomListsService.getSelectArray("typeOfAccidentV2");

                case 59:
                  this.typeOfAccidentList = _context7.sent;

                  if (!(this.slot && this.slot.operatorId)) {
                    _context7.next = 64;
                    break;
                  }

                  _context7.next = 63;
                  return this.OperatorsService.getNameById(this.slot.operatorId);

                case 63:
                  this.slot.operatorName = _context7.sent;

                case 64:
                  if (this.depaStatus === "Effectué") {
                    this.setMode("comment");
                  } else if (this.depaStatus === "Annulé") {
                    this.setMode("mailOrSms");
                  } else {
                    this.setMode("scheduleLvr");
                  }
                  _context7.next = 68;
                  break;

                case 67:
                  this.setMode("schedule");

                case 68:

                  Notiflix.Loading.remove();

                  // https://stackoverflow.com/questions/34907903/angularjs-scope-not-updating-in-view-after-async-call
                  this.$scope.$applyAsync();

                case 70:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, this);
        }));

        function $onInit() {
          return _ref7.apply(this, arguments);
        }

        return $onInit;
      }()
    }]);

    return Controller;
  }();

  angular.module(moduleName).component(componentName, {
    templateUrl: templateUrl,
    bindings: bindings,
    //transclude: true,
    controller: Controller
  });
})();